import { useMutation, useQueryClient } from "@tanstack/react-query";

import { InvestmentRefreshResponse, refreshInvestmentTicker } from "@features/investments/api";
import { dashboardQueryKey } from "./dashboard";
import { equityDetailQueryKey } from "./equity-detail";
import { etfDetailQueryKey } from "./etf-detail";
import { instrumentCatalogQueryKey } from "./catalog";
import { investmentQuoteQueryKey } from "./quote";
import { publicationStatusQueryKey, runtimeStatusQueryKey } from "./runtime";

export function useRefreshInvestmentMutation() {
  const queryClient = useQueryClient();
  return useMutation<InvestmentRefreshResponse, Error, string>({
    mutationFn: (ticker: string) => refreshInvestmentTicker(ticker),
    onSettled: async (_result, _error, ticker) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: dashboardQueryKey }),
        queryClient.invalidateQueries({ queryKey: instrumentCatalogQueryKey(ticker) }),
        queryClient.invalidateQueries({ queryKey: equityDetailQueryKey(ticker) }),
        queryClient.invalidateQueries({ queryKey: etfDetailQueryKey(ticker) }),
        queryClient.invalidateQueries({ queryKey: investmentQuoteQueryKey(ticker) }),
        queryClient.invalidateQueries({ queryKey: runtimeStatusQueryKey }),
        queryClient.invalidateQueries({ queryKey: publicationStatusQueryKey }),
      ]);
    },
  });
}
